// extracted by mini-css-extract-plugin
module.exports = {"root":"EABD2CaseFooter_root__1B4Mz"};